import styled from 'styled-components'
import { ButtonMenu, ButtonMenuItem, Text, Flex, NotificationDot } from '@pancakeswap/uikit'
import ToggleView from './ToggleView/ToggleView'
import { useEffect, useState } from 'react'
import { Box, Switch } from '@mui/material';
import { styled as mstyled } from '@mui/material/styles';

import Select from "../../../components/Select/Select";
import SearchInput from "../../../components/SearchInput";
import { useWeb3React } from '@web3-react/core';

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
  ${Text} {
    margin-left: 8px;
  }
`
const PButtonMenu = styled(ButtonMenu)`
  background-color : #1A3342;
  box-shadow: 0px 0px 0px 1px #00FED9 ;
  border : none !important;
`
const PButtonMenuItem = styled(ButtonMenuItem)`
  color: #000000;
  &:hover{
    background-color : #00FED9;
  }
`

const ToggleButton = mstyled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#00FED9',
      },
    },
  },
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    backgroundColor: '#B1B3CB',
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));

const ViewControls = styled.div`
display: flex;
flex-wrap: wrap;
/* justify-content: space-between; */
align-items: center;
width: 100%;
margin-top: 20px;

  > div {
  padding: 8px 0px;
}

  ${({ theme }) => theme.mediaQueries.md} {
  justify-content: flex-start;
  width: auto;

    > div {
    padding: 0;
  }
}
`

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  a {
  padding-left: 12px;
  padding-right: 12px;
}

  ${({ theme }) => theme.mediaQueries.sm} {
  margin-left: 16px;
}
`
const FilterContainer = styled.div`
display: flex;
align-items: center;
width: 100%;
padding: 8px 0px;

  ${({ theme }) => theme.mediaQueries.sm} {
  width: auto;
  padding: 0;
}
`;
const LabelWrapper = styled.div`
  > ${Text} {
  font-size: 12px;
}
`;
const ControlStretch = styled(Flex)`
  > div {
  flex: 1;
}
`;

interface PoolTabButtonsType {
  stackChange?: any;
  setSearchValue?: any;
  searchvalue?: any;
  setIsToggleview?: any;
  isChecked?: any;
  isLive?: any;
  handleSortOptionChange?: any;
  setHandleSortOptionChange?: any;
  setIsChecked?: any;
  setIsLive?: any;
}

const PoolTabButtons: React.FC<PoolTabButtonsType> = ({ stackChange, setSearchValue, searchvalue, setIsToggleview, isChecked, isLive, handleSortOptionChange, setHandleSortOptionChange, setIsChecked, setIsLive }) => {
//   const [isChecked, setIsChecked] = useState(false);
//   const [isLive, setIsLive] = useState(true);
//   const [handleSortOptionChange, setHandleSortOptionChange] = useState(0);
  const { active } = useWeb3React();
  const [options, setOptions] = useState([
    {
      label: "Hot",
      value: "hot",
    },
    {
      label: "APY",
      value: "apy",
    },
    {
      label: "Total staked",
      value: "totalStaked",
    },
    {
      label: "Latest",
      value: "latest",
    },
  ])
  useEffect(() => {
    let options = [];
    if (active) {
      options = [
        {
          label: "Hot",
          value: "hot",
        },
        {
          label: "APY",
          value: "apy",
        },
        {
          label: "Earned",
          value: "earned",
        },
        {
          label: "Total staked",
          value: "totalStaked",
        },
        {
          label: "Latest",
          value: "latest",
        },
      ]
    } else {
      options = [
        {
          label: "Hot",
          value: "hot",
        },
        {
          label: "APY",
          value: "apy",
        },
        {
          label: "Total staked",
          value: "totalStaked",
        },
        {
          label: "Latest",
          value: "latest",
        },
      ]
    }
    setOptions(options);
  }, [active])

  // const filterLive = () => {
  //   setIsLive(!isLive);
  // }

  const toggle = () => {
    setIsChecked(!isChecked);
  }
//   useEffect(() => {
//     stackChange(isChecked, isLive, handleSortOptionChange, searchvalue)
//   }, [isChecked, isLive, handleSortOptionChange, searchvalue])
  // const viewModeToggle = (
  //   <ToggleView idPrefix="clickPool" />
  // )
  const viewModeToggle = (
    <ToggleView setIsToggleview={setIsToggleview} />
  )


  const liveOrFinishedSwitch = (
    <Wrapper>
      <PButtonMenu scale="sm" activeIndex={isLive ? 0 : 1}>
        <PButtonMenuItem>
          <Box onClick={() => setIsLive(true)} sx={{ ...(!isLive && { color: 'white' }), fontWeight: '400' }}>
            Live
          </Box>
        </PButtonMenuItem>
        <PButtonMenuItem id="finished-pools-button">
          <Box onClick={() => setIsLive(false)} sx={{ ...(isLive && { color: 'white' }), fontWeight: '400' }}>
            Finished
          </Box>
        </PButtonMenuItem>
      </PButtonMenu>
    </Wrapper>
  )

  const stakedOnlySwitch = (
    <ToggleWrapper>
      {/* <Toggle scale="sm" /> */}
      <ToggleButton checked={isChecked} onChange={toggle} disabled={!active} />
      <Text color={'white'}> Staked only</Text>
    </ToggleWrapper>
  )


  return (
    <>
      <ViewControls>
        <Box sx={{ display: ' flex' }}>
          {viewModeToggle}
          {stakedOnlySwitch}
        </Box>
        {liveOrFinishedSwitch}
      </ViewControls>
      <FilterContainer>
        <LabelWrapper>
          <Text
            fontSize="12px"
            fontWeight={400}
            color="white"
            textTransform="uppercase"
            paddingBottom="3px"
          >
            Sort by
          </Text>
          <ControlStretch>
            <Select
              options={options}
              onOptionChange={(option) => setHandleSortOptionChange(option.value)}
            />
          </ControlStretch>
        </LabelWrapper>
        <LabelWrapper style={{ marginLeft: 16 }}>
          <Text
            fontSize="12px"
            fontWeight={400}
            color="white"
            textTransform="uppercase"
            paddingBottom="3px"
          >
            Search
          </Text>
          <SearchInput setSearchValue={setSearchValue} />
        </LabelWrapper>
      </FilterContainer>
    </>
  )
}

export default PoolTabButtons
